import Vue from 'vue';
import Vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css';
import '@shared/styles/index.css';
import './style.css';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './config';
import api from '@shared/services/api';
import { DialogService } from '@shared/services/dialogService';
Vue.config.productionTip = false;
Vue.prototype.$config = config;
Vue.prototype.$api = api;
// "Editorial paper": warm paper, ink type and one terracotta clay accent (dev plan, area 1).
const vuetify = new Vuetify({ theme: { dark: false, options: { customProperties: true }, themes: { light: {
  primary: '#B4472B', secondary: '#1F2328', accent: '#B4472B', error: '#B42318', info: '#2B5F8A', success: '#2F7D4F', warning: '#A15C07'
} } }, icons: { iconfont: 'mdi' } });
const app = new Vue({ vuetify, router, store, render: h => h(App) }).$mount('#app');
window.router = router;
DialogService.setAppInstance(app);
